import { FC, PropsWithChildren } from 'react';

import { cn } from 'utils/helpers';
import BackgroundImage from 'assets/images/Login-Bg.png';

interface PROPS extends PropsWithChildren {
  className?: string;
}

const PublicWrapper: FC<PROPS> = ({ children, className }) => {
  return (
    <div
      style={{ backgroundImage: `url(${BackgroundImage})` }}
      className={cn(
        'w-screen min-h-screen',
        'bg-fill-primary',
        'bg-right-bottom bg-no-repeat',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default PublicWrapper;
